
function HamburgerMenuOverlay() {

    return (<div 
        style={{position: "absolute", height: "100%", width: "100%", backgroundColor: "black", opacity: "0.3", zIndex: "1"}}>
        </div>
        );
}

export default HamburgerMenuOverlay;